<template>
  <div :class="classes">
    <div class="bx-complementary-content">
      <h6 v-if="title" class="bx-box-title">
        <span v-html="title"></span>
      </h6>
      <div class="bx-complementary-values">
        <div class="bx-value-left">
          <span>{{ formatQty(left.value) }}</span>
          <bx-tag v-if="left.tag" :color="left.tagColor">{{ left.tag }}</bx-tag>
        </div>
        <div class="bx-value-right">/ {{ formatQty(rightValue) }}</div>
      </div>
      <div class="bx-complementary-bar">
        <div class="bx-bar" :style="`width: ${leftPercent}%`"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bx-complementary",
  props: {
    total: {
      type: Number,
      required: true
    },
    totalIcon: {
      type: String
    },
    left: {
      value: {
        type: Number,
        required: true
      },
      label: {
        type: String
      },
      icon: {
        type: String
      },
      tag: {
        type: [String, Number]
      },
      tagColor: {
        type: String
      }
    },
    right: {
      value: {
        type: Number
      },
      label: {
        type: String
      },
      icon: {
        type: String
      }
    },
    title: {
      type: String,
      default: null
    }
  },
  computed: {
    classes() {
      const classes = ["bx-complementary"];
      return classes;
    },
    rightValue() {
      return this.right.value ? this.right.value : this.total - this.left.value;
    },
    leftPercent() {
      let percent = (this.left.value / this.total) * 100;
      return percent > 100 ? 100 : percent;
    }
  }
};
</script>
